import { computed, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useRouteParams } from "@vueuse/router";
import { useContentCommandApi } from "@/composables/useContentCommandApi";
import type { ExperienceTranslation } from "@/types/generated/ContentCommandApi";
import builder from "@rsql/builder";
import { emit } from "@rsql/emitter";

export const EXPERIENCE_TRANSLATIONS_QUERY_KEY = "experience-curation-translations";

export function useExperienceTranslationsQuery(experienceId: Ref<string>) {
  const { getTranslations } = useContentCommandApi();

  return useQuery({
    queryKey: [EXPERIENCE_TRANSLATIONS_QUERY_KEY, experienceId],
    queryFn: async () => {
      const params = {
        filters: emit(builder.eq("experience_id", experienceId.value)),
        language_code: "en" as const,
      };

      const { data } = await getTranslations<ExperienceTranslation[]>("experience-translations", { params });
      return data[0];
    },
    select: (data) => data,
    enabled: computed(() => !!experienceId.value),
  });
}

export function useCurrentExperienceTranslationsQuery() {
  const experienceId = useRouteParams<string>("id");
  return useExperienceTranslationsQuery(experienceId);
}
